module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result31-46e2504a24b3daacbc645d9aa14ca588.png";